import axios from 'axios';

const customAxios = axios.create();

customAxios.interceptors.response.use(
  (response) => response, // Para respuestas exitosas, simplemente devuelve la respuesta.
  (error) => {
    // Tu lógica específica para manejar errores 401.
    if (
      error.response &&
      error.response.status === 401 &&
      window.location.pathname !== '/nonauth'
    ) {
      let path;
      const regex = /Redirecting to (.+)/;
      const matches = error.response.data.match(regex);
      if (matches && matches[1]) {
        path = matches[1];
      }

      window.location.href = path;
      // Considera devolver un Promise.reject para asegurar que la cadena de promesas se maneje adecuadamente.
      return Promise.reject(error);
    }

    // Importante: Rechaza el error si no se cumple la condición anterior.
    // Esto asegura que los errores sean propagados y puedan ser capturados por .catch().
    return Promise.reject(error);
  }
);

export default customAxios;
